// services/projectService.ts
import axiosInstance from "./axiosInstance";

// ================== Project CRUD ==================
export const fetchProjects = async (): Promise<any[]> => {
  const response = await axiosInstance.get("/Projects");
  return response.data.data; // array of projects
};

export const createProject = async (project: any) => {
  const response = await axiosInstance.post("/CreateProject", project);
  return response.data;
};

export const UpdateProject = async (payload: any) => {
  const res = await axiosInstance.put("/UpdateProject", payload);
  return res.data;
};

export const deleteProject = async (id: number): Promise<{ data: string }> => {
  const response = await axiosInstance.delete(`/Project/${id}`);
  return response;
};

// ================== Master Data for Add Project ==================
export const GetCustomers = async (): Promise<any[]> => {
  const response = await axiosInstance.get("/customers");
  return response.data.data;
};

export const GetPayTerms = async (): Promise<any[]> => {
  const response = await axiosInstance.get("/GetPayTerms");
  return response.data.data;
};
